import { Card, CardContent, CardDescription, CardHeader, CardTitle, Grid, Text } from '@careflux/primitives';
import type { EditDistributionCardProps } from './components.types';
import { SUPPRESSED_LABEL, formatNumber } from './formatting';
import { distributionToneVariants } from './summaryQuality.styles';
import type { EditDistribution } from './types';

const BUCKETS: { key: keyof EditDistribution; label: string; tone: 'none' | 'minimal' | 'moderate' | 'major' }[] = [
  { key: 'noEdits', label: 'Engar breytingar (<1%)', tone: 'none' },
  { key: 'minimal', label: 'Lítilsháttar (<10%)', tone: 'minimal' },
  { key: 'moderate', label: 'Í meðallagi (<30%)', tone: 'moderate' },
  { key: 'major', label: 'Miklar (≥30%)', tone: 'major' },
];

export const EditDistributionCard = ({ distribution, suppressed }: EditDistributionCardProps) => (
  <Card padding="lg">
    <CardHeader>
      <CardTitle>Dreifing breytinga</CardTitle>
      <CardDescription>Fjöldi paraðra samantekta eftir hlutfalli breyttra orða</CardDescription>
    </CardHeader>
    <CardContent>
      {suppressed || !distribution ? (
        <Text size="sm" color="muted">
          {SUPPRESSED_LABEL}
        </Text>
      ) : (
        <Grid columns={{ base: 2, md: 4 }} gap="md">
          {BUCKETS.map((bucket) => (
            <div key={bucket.key} className={distributionToneVariants({ tone: bucket.tone })}>
              <Text asChild size="2xl" weight="bold" color="inherit" className="tabular-nums">
                <p>{formatNumber(distribution[bucket.key])}</p>
              </Text>
              <Text asChild size="xs" color="inherit">
                <p>{bucket.label}</p>
              </Text>
            </div>
          ))}
        </Grid>
      )}
    </CardContent>
  </Card>
);
